export default __webpack_public_path__ + "static/media/Sign.a5a53b0f.jpg";